const mentions = {
  configureModules(modules) {
    const mentionParticipants = [
      this.el.dataset.groupMentionText,
      ...JSON.parse(this.el.dataset.mentionParticipants).map(
        (mp) => mp.string_id,
      ),
    ].map((value) => ({ value }))

    const hook = this
    // Capture phase: the comment feed scrolls in a nested container, and
    // scroll events do not bubble — window only sees them when capturing.
    hook.repositionMentionList = () =>
      hook.quill?.getModule("mention")?.setMentionContainerPosition()

    return {
      ...modules,
      mention: {
        dataAttributes: ["id"],
        allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
        mentionDenotationChars: ["@"],
        // "normal" appends the list inside quill.container, where the comment
        // editor's overflow-hidden ancestor clips it to ~one row (ENA-9777).
        // "fixed" appends to document.body, escaping ancestor overflow. The
        // list must then track the caret through scrolling itself: the
        // listener below lives only while the list is open.
        positioningStrategy: "fixed",
        onOpen: () =>
          window.addEventListener("scroll", hook.repositionMentionList, true),
        onClose: () =>
          window.removeEventListener(
            "scroll",
            hook.repositionMentionList,
            true,
          ),
        source: function (searchTerm, renderList) {
          let values = mentionParticipants

          if (searchTerm.length === 0) {
            renderList(values, searchTerm)
          } else {
            const matches = []
            for (let i = 0; i < values.length; i++)
              if (
                ~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
              )
                matches.push(values[i])
            renderList(matches, searchTerm)
          }
        },
      },
    }
  },
}

export default mentions
